import { NgModule } from '@angular/core';
import { InjectionToken } from '@angular/core';
export const REST_SERVER_HOST = new InjectionToken<string>('REST_SERVER_HOST');
export const FIREBASE_INFO = new InjectionToken<any>('FIREBASE_INFO');
export const SCHOOLBELLE_LOGIN_FRONT_HOST = new InjectionToken<string>('SCHOOLBELLE_LOGIN_FRONT_HOST');

@NgModule({
})
export class SurveyTokensModule {
  static forRoot(ENV:{
    serverHost?:string,
    firebase:any,
    schoolbelleLoginFrontHost:string,
  }) {
    return {
      ngModule:SurveyTokensModule,
      providers:[
        { provide: REST_SERVER_HOST, useValue: ENV.serverHost },
        { provide: FIREBASE_INFO, useValue: ENV.firebase },
        { provide: SCHOOLBELLE_LOGIN_FRONT_HOST, useValue: ENV.schoolbelleLoginFrontHost },
      ]
    }    
  }
}